'use strict';

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Response = require('./Response');

var _Response2 = _interopRequireDefault(_Response);

var _deepCopy = require('./deepCopy');

var _deepCopy2 = _interopRequireDefault(_deepCopy);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var MockFetch = function () {
  function MockFetch() {
    var responseFactory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (status, headers, body) {
      return new _Response2["default"](status, headers, body);
    };
    (0, _classCallCheck3["default"])(this, MockFetch);
    this.calls = [];
    this.responseMapping = [];
    this.responseFactory = responseFactory;
  }

  (0, _createClass3["default"])(MockFetch, [{
    key: 'registerResponse',
    value: function registerResponse(method, url, response) {
      this.responseMapping.push({
        method: method,
        url: url,
        response: response
      });
      return this;
    }
  }, {
    key: 'registerResponseOnce',
    value: function registerResponseOnce(method, url, response) {
      this.responseMapping.push({
        method: method,
        url: url,
        response: response,
        callOnlyOnce: true
      });
    }
  }, {
    key: 'registerError',
    value: function registerError(method, url, error) {
      this.responseMapping.push({
        method: method,
        url: url,
        error: error
      });
    }
  }, {
    key: 'evaluateCallForResponse',
    value: function evaluateCallForResponse(url, _ref) {
      var _ref$method = _ref.method,
          method = _ref$method === undefined ? 'GET' : _ref$method;
      var mapping = this.responseMapping.find(function (res) {
        return res.method === method && res.url === url;
      });

      if (!mapping) {
        return this.responseFactory(200);
      }

      if (mapping.error) {
        return mapping.error;
      }

      if (mapping.callOnlyOnce) {
        var mappingIndex = this.responseMapping.indexOf(mapping);
        this.responseMapping.splice(mappingIndex, 1);
      }

      var headers = mapping.response.headers ? mapping.response.headers : {};
      return this.responseFactory(mapping.response.status, headers, mapping.response.body);
    }
  }, {
    key: 'mock',
    value: function mock() {
      var _this = this;

      return function () {
        var _ref2 = (0, _asyncToGenerator3["default"])( /*#__PURE__*/_regenerator2["default"].mark(function _callee(url, options) {
          var opts, call, response;
          return _regenerator2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  opts = (0, _deepCopy2["default"])(options) || {};
                  call = {
                    url: url,
                    opts: opts,
                    callTime: new Date().getTime()
                  };
                  response = _this.evaluateCallForResponse(url, opts);
                  call.response = response;

                  _this.calls.push(call);

                  if (!(response instanceof Error)) {
                    _context.next = 7;
                    break;
                  }

                  throw response;

                case 7:
                  return _context.abrupt('return', response);

                case 8:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x2, _x3) {
          return _ref2.apply(this, arguments);
        };
      }();
    }
  }]);
  return MockFetch;
}();

exports["default"] = MockFetch;